import React from 'react';

import AuthContainer from 'src/components/AuthContainer';

import Login from 'src/pages/auth/Login';
import SignUpPatient from 'src/pages/auth/SignupPatient';
import SignupDoctor from 'src/pages/auth/SignupDoctor';
import WelcomeUser from './WelcomeUser';
import SignupClinic from './SignupClinic';
import RemoveAccountForm from './RemoveAccountForm';
import PhoneVerification from './Verification/PhoneVerification';
import EmailVerification from './Verification/EmailVerification';
import Home from './Home';
import HomeClinic from './Home/HomeClinic';
import HomeDoctor from './Home/HomeDoctor';

export default {
  HOME_PAGE: {
    name: 'home_page',
    path: '/home',
    element: <Home />
  },
  HOME_DOCTOR_PAGE: {
    name: 'home_doctor_page',
    path: '/home_doctor',
    element: <HomeDoctor />
  },
  HOME_CLINIC_PAGE: {
    name: 'home_clinic_page',
    path: '/home_clinic',
    element: <HomeClinic />
  },
  PAGE2_PAGE: {
    name: 'home2_page',
    path: '/home2',
    element: <WelcomeUser />
  },
  LOGIN_PAGE: {
    name: 'login_page',
    path: '/login',
    element: (
      <AuthContainer>
        <Login />
      </AuthContainer>
    )
  },
  SIGNUP_PAGE: {
    name: 'signup',
    path: '/signup',
    match: () => `/signup`,
    element: <SignUpPatient />
  },
  SIGNUP_DOCTOR_PAGE: {
    name: 'signup_doctor_page',
    path: '/signup-doctor',
    match: () => `/signup-doctor`,
    element: <SignupDoctor />
  },
  SIGNUP_CLINIC_PAGE: {
    name: 'signup_clinic_page',
    path: '/signup-clinic',
    match: () => `/signup-clinic`,
    element: <SignupClinic />
  },
  ACCOUNT_REMOVAL_PAGE: {
    name: 'account_removal',
    path: '/account_removal',
    element: (
      <AuthContainer>
        <RemoveAccountForm />
      </AuthContainer>
    )
  },
  PHONE_VERIFICATION_PAGE: {
    path: '/phone_verification',
    checkActive: ({ auth }) => !!auth,
    element: <PhoneVerification />
  },
  EMAIL_VERIFICATION_PAGE: {
    path: '/email_verification',
    element: (
      <AuthContainer>
        <EmailVerification />
      </AuthContainer>
    )
  }
};
